export default __webpack_public_path__ + "static/media/logo-big.c16e7003.png";